import { getDashboardCalendarPath, getDashboardLoginPath } from "../utils/dashboardPaths";

/**
 * OAuth redirect URIs must match exactly what is passed to auth_request_url and
 * validate_auth_token, and each URI must be registered on the Google Cloud OAuth
 * client under "Authorized redirect URIs".
 *
 * Profile login exchanges the code on LoginPage; calendar linking exchanges on CalendarPage.
 */
export function getOAuthRedirectUriForLogin(): string {
  return `${window.location.origin}${getDashboardLoginPath()}`;
}

export function getOAuthRedirectUriForCalendar(): string {
  return `${window.location.origin}${getDashboardCalendarPath()}`;
}

/** @deprecated Use getOAuthRedirectUriForLogin() for clarity. */
export function getOAuthRedirectUri(): string {
  return getOAuthRedirectUriForLogin();
}
